var Trix = require("trix");
Trix.config.blockAttributes.heading2 = { tagName: "h2", terminal: true, breakOnReturn: true, group: false };
require("@rails/actiontext");

var VIDEO_URL_PATTERN = /https?:\/\/(www\.)?(youtube\.com\/watch\?[\w=&-]+|youtu\.be\/[\w-]+([?&][\w=&%-]*)*|vimeo\.com\/\d+([?&][\w=&%-]*)*)/;
var pasteHandlerInstalled = new WeakSet();

function getEmbedsPath() {
  var meta = document.querySelector('meta[name="trix-embeds-path"]');
  return meta && meta.content;
}

function insertEmbed(editor, url, beforeInsert) {
  var embedsPath = getEmbedsPath();
  if (!embedsPath) return;

  $.ajax({
    method: "POST",
    url: embedsPath,
    data: { embed: { url: url } },
    success: function (response) {
      var content = response.content;
      var sgid = response.sgid;
      var thumbnailUrl = response.thumbnail_url;

      if (beforeInsert) {
        var previewUrl = beforeInsert(thumbnailUrl);
        if (previewUrl) {
          content = '<div style="position:relative">' +
            '<img src="' + previewUrl + '" style="width:100%;display:block" />' +
            '<div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:48px;color:white;text-shadow:0 0 8px rgba(0,0,0,0.75)">▶</div>' +
            '</div>';
        }
      }

      var attachment = new Trix.Attachment({ content: content, sgid: sgid });
      editor.insertAttachment(attachment);
      editor.insertLineBreak();
    },
    error: function (e) {
      console.error("Embed failed:", e);
    }
  });
}

function addPasteHandler(trixEditor) {
  trixEditor.addEventListener("trix-paste", function (event) {
    var pastedText = event.paste && event.paste.string;
    if (!pastedText) return;

    var trimmed = pastedText.trim();
    var match = trimmed.match(VIDEO_URL_PATTERN);
    if (!match) return;

    var url = match[0];
    var editor = trixEditor.editor;

    insertEmbed(editor, url, function (thumbnailUrl) {
      var docString = editor.getDocument().toString();
      var urlIndex = docString.indexOf(trimmed);
      if (urlIndex !== -1) {
        editor.setSelectedRange([urlIndex, urlIndex + trimmed.length]);
      }
      return thumbnailUrl;
    });
  });
}

function customizeToolbar(trixEditor) {
  if (!trixEditor.toolbarElement) return;

  var blockGroup = trixEditor.toolbarElement.querySelector('.trix-button-group--block-tools');

  if (!blockGroup.querySelector('[data-trix-attribute="heading2"]')) {
    blockGroup.firstElementChild.remove();
    blockGroup.insertAdjacentHTML("afterbegin", '<button class="trix-button" type="button" data-trix-attribute="heading2" title="Heading 2" tabindex="-1">H2</button>');
    blockGroup.insertAdjacentHTML("afterbegin", '<button class="trix-button" type="button" data-trix-attribute="heading1" title="Heading 1" tabindex="-1">H1</button>');
  }

  if (getEmbedsPath() && !pasteHandlerInstalled.has(trixEditor)) {
    pasteHandlerInstalled.add(trixEditor);
    addPasteHandler(trixEditor);
  }
}

addEventListener("trix-initialize", function(event) {
  customizeToolbar(event.target);
});
